<template>
  <section class="scene" id="thanks">
    <div class="static-container"></div>
  </section>
</template>

<script>
export default {
  name: "Thanks",
};
</script>
